import { configureLogger, type LogLevel } from "./index.ts";

type BufferedLine = { level: LogLevel; line: Record<string, unknown> };

// Ring buffer keeps the last N lines in memory so copyDebugLog can dump them.
const BUFFER_MAX = 500;
const buffer: BufferedLine[] = [];

export const initBrowserLogger = (opts: { minLevel?: LogLevel } = {}): void => {
  configureLogger({
    minLevel: opts.minLevel ?? "debug",
    sink: (level, line) => {
      buffer.push({ level, line });
      if (buffer.length > BUFFER_MAX) buffer.shift();
      const json = JSON.stringify(line);
      if (level === "error") console.error(json);
      else if (level === "warn") console.warn(json);
      else if (level === "debug") console.debug(json);
      else console.log(json);
    },
  });
};

export const getDebugLog = (): string => buffer.map((b) => JSON.stringify(b.line)).join("\n");

export const copyDebugLog = async (): Promise<boolean> => {
  const text = getDebugLog();
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};

export const clearDebugLog = (): void => { buffer.length = 0; };
